import { createFileRoute } from '@tanstack/react-router';

import { ReportPage } from '@/features/risk-assessment/components/report-page';

export const Route = createFileRoute('/_authenticated/risk-assessment/$id/report')({
  component: ReportPageRoute,
});

function ReportPageRoute() {
  const { id } = Route.useParams();
  return <ReportPage assessmentId={id} />;
}
